import styled from "styled-components";
export const AuthContainer = styled.section`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 80vh;
  .form {
    width: 100%;
    max-width: 400px;
    padding: 16px;
    .buttons {
      margin: 16px 0;
      button {
        width: 100%;
      }
    }
    .form-item {
      margin-bottom: 8px;
    }
    .otp {
      direction: ltr;
      display: flex;
      justify-content: space-between;
      input {
        width: 19% !important;
        text-align: center !important;
        border: none !important;
        border-radius: 0;
        border-bottom: solid 1px ${({ theme }) => theme.colors.inputBorder} !important;
        margin: 0 !important;
        font-size: 26px !important;
        font-family: sans-serif !important;
        line-height: 26px;
      }
    }
    .buttons {
      margin-bottom: 8px;
    }
    .notice {
      margin-bottom: 8px;
      .link {
        font-weight: bold;
        cursor: pointer;
        &:hover {
          color: ${({ theme }) => theme.colors.linkHover};
        }
      }
    }
  }
`;
export const CounterContainer = styled.div`
  font-size: 12px;
  span {
    font-weight: bold;
  }
  .resend {
    display: inline-block;
    font-size: 14px;
    font-weight: bold;
    cursor: pointer;
    &:hover {
      color: ${({ theme }) => theme.colors.linkHover};
    }
  }
`;
